import React, { useState } from 'react';
import { Container } from 'reactstrap';
import { Box } from '@mui/material';

import { useNavigate, useParams, Outlet, useLocation } from 'react-router-dom';
import { PageHeader } from './PageHeader';
import Unauthorized from '../Layout/Router/Unauthorized';
import PortalPageLoader from '../common/PortalPageLoader';
import { AccessManagerModal } from './AccessManagerModal';
import { getPageDetails } from './config';
import { useCourseAccess } from './utils';

export const SSA = () => {
  const { termCode, crn } = useParams();
  const { courseAccess, isLoading, isTestingAllowed, isCourseActive, isCourseUpdatable, minCrn } =
    useCourseAccess(termCode, crn);

  const [isAccessManagerModalOpen, setIsAccessManagerModalOpen] = useState(false);

  const location = useLocation();
  const navigate = useNavigate();

  // Get page config
  const paths = location.pathname.split('/').filter(Boolean);
  const subPath = paths[1]?.toLowerCase();

  const subPage = getPageDetails({ termCode, crn })[subPath.toLowerCase()];

  const pageActions = [];

  if (!subPage) {
    const reportPage = getPageDetails({
      termCode,
      crn,
    })['report'];

    pageActions.push({
      title: reportPage.title,
      handler: () => navigate(reportPage.page),
    });

    if (courseAccess.isSSASuperUser) {
      pageActions.push({
        title: 'Manage Access',
        handler: () => setIsAccessManagerModalOpen(true),
      });
    }
  }

  return isLoading ? (
    <PortalPageLoader />
  ) : !courseAccess.isSSAUser && !courseAccess.isSSASuperUser ? (
    <Unauthorized />
  ) : (
    <div className="myOdu__ssa">
      <AccessManagerModal
        termCode={termCode}
        crn={minCrn}
        isOpen={isAccessManagerModalOpen}
        onClose={() => setIsAccessManagerModalOpen(false)}
      />
      <Container className="myOdu__container secondaryPage layout">
        <Box id="ssa__box_wrapper" className="wrapper">
          <PageHeader
            course={courseAccess.course}
            actions={pageActions}
            isTestingAllowed={isTestingAllowed}
            isCourseActive={isCourseActive}
          />
          <Outlet
            context={{
              termCode,
              isCourseUpdatable,
              minCrn,
            }}
          />
        </Box>
      </Container>
    </div>
  );
};
